import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FieldType, FormlyModule } from "@ngx-formly/core";
import { Message } from "primeng/message";
import { NewUiAutocompleteComponent } from "../../shared/form/autocomplete/new-ui-autocomplete.component";
import { NewUiFormElementMapModule } from "../../shared/from-element-map/new-ui-form-element-map.module";
import { TestIdDirective } from "../../shared/test-id/test-id.directive";

@Component({
  selector: "new-ui-formly-chips-input",
  templateUrl: "./new-ui-formly-chips-input.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NewUiAutocompleteComponent,
    ReactiveFormsModule,
    FormlyModule,
    NewUiFormElementMapModule,
    TestIdDirective,
    Message,
  ],
})
export class NewUiFormlyChipsInputComponent extends FieldType {}
